import { Component, Input } from '@angular/core';
import { responseTimeAdapter } from '@modules/reports/models/response-time';

@Component({
  selector: 'mojo-dashboard-avg-response-time',
  styleUrls: ['./dashboard-average-response-time.component.scss'],
  templateUrl: './dashboard-average-response-time.component.html',
})
export class DashboardAverageResponseTimeComponent {
  @Input() avgResponseTime: string;

  responseTimeAdapterFunction = responseTimeAdapter;
}
